import { SelectItemType } from "@ecologi/react-components/src/Select";
import { DateTime } from "luxon";

export const getYearSelectOptions = (from: number) => {
  const currentYear = DateTime.local().year;
  const years: SelectItemType[] = [];
  for (let year = from; year <= currentYear; year++) {
    years.push({ label: String(year), value: String(year) });
  }
  return years;
};
